import { render, staticRenderFns } from "./admin-after-demo-booking-surveys.vue?vue&type=template&id=3c503dec&scoped=true&"
import script from "./admin-after-demo-booking-surveys.vue?vue&type=script&lang=js&"
export * from "./admin-after-demo-booking-surveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c503dec",
  null
  
)

export default component.exports